var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"colse-btn",on:{"click":_vm.closeDia}},[_vm._v("⨯")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"title"},[_vm._v("1111111111111111111111")]),_c('div',{staticClass:"content"})])
}]

export { render, staticRenderFns }